import { render } from "./DetailPaiement.vue?vue&type=template&id=e8b9aa4c&scoped=true"
import script from "./DetailPaiement.vue?vue&type=script&lang=js"
export * from "./DetailPaiement.vue?vue&type=script&lang=js"

import "./DetailPaiement.vue?vue&type=style&index=0&id=e8b9aa4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b9aa4c"]])

export default __exports__